/* eslint-disable react/jsx-no-bind */
import React from 'react';
import { Box, Flex, Text, theme } from 'pcln-design-system';
import { InformationOutline } from 'pcln-icons';
import { messageInputConfig } from '../../constants';
const InputLimiter = ({
  currentLength
}) => {
  const {
    MAXLENGTH,
    WARNLENGTH
  } = messageInputConfig;
  const exceedsMaxLength = currentLength >= MAXLENGTH;
  const exceedsWarnLength = currentLength >= WARNLENGTH;
  return React.createElement(React.Fragment, null, exceedsWarnLength && !exceedsMaxLength && React.createElement(Flex, {
    pl: '12px',
    justifyContent: 'flex-start',
    pt: 1,
    id: 'inputLimiterWarn',
    "data-testid": 'inputLimiterWarn'
  }, React.createElement(Box, {
    mr: 1
  }, React.createElement(InformationOutline, {
    size: 16,
    color: theme.colors.lightText
  })), React.createElement(Box, null, React.createElement(Text, {
    mt: '1px',
    textStyle: 'caption',
    color: theme.colors.lightText
  }, ' ', currentLength, " of ", MAXLENGTH, " character limit."))), exceedsMaxLength && React.createElement(Flex, {
    pl: '12px',
    justifyContent: 'flex-start',
    pt: 1,
    id: 'inputLimiterExceed',
    "data-testid": 'inputLimiterExceed'
  }, React.createElement(Box, {
    mr: 1
  }, React.createElement(InformationOutline, {
    size: 16,
    color: theme.colors.red
  })), React.createElement(Box, null, React.createElement(Text, {
    mt: '1px',
    textStyle: 'caption',
    color: theme.colors.red
  }, ' ', "Character limit of ", MAXLENGTH, " reached."))));
};
export default InputLimiter;